import React, { useEffect, useState } from "react";
import DataTable, { createTheme } from 'react-data-table-component';
import {getJWTHeaders} from "../../common/server";
import { Link } from 'react-router-dom';
import {Button, Container, Form, FormGroup, Row, Col} from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {handleResponse} from "../../common/server";
import { confirmAlert } from 'react-confirm-alert';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

export default function Tablecoupon() {

	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [totalRows, setTotalRows] = useState(0);
	const [perPage, setPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [until, setUntil] = useState(new Date());
	const [film, setFilm] = useState([]);
	const [editingRow, setEditingRow] = useState(null);
	const [editValues, setEditValues] = useState({});
	const [searchText, setSearchText] = useState('');
	
	

	let emptyFilter = {    
		page: currentPage,
		max:perPage,
		sortcol:"idcoupon",
		direction:"desc",
		search: ""		
	  };

	  const [currentFilter, setFilter] = useState(emptyFilter);

	  let emptyCoupon = {
    
		quantity : 1,
		name:'',
		until: null ,
		groupinfo:'',
		pax: 1
		
	  };

	  const [currentCoupon, setCurrentCoupon] = useState(emptyCoupon);


	  const deleteCoupon = (event) => {
		let idcoupon = null;
		if(event.target.parentElement.attributes.getNamedItem('idtodelete'))
		idcoupon = event.target.parentElement.attributes.getNamedItem('idtodelete').value;
		else if (event.target.attributes.getNamedItem('idtodelete'))
		idcoupon = event.target.attributes.getNamedItem('idtodelete').value;
		else
		console.log(event);
		
		confirmAlert({
		  title: 'Conferma eliminazione',
		  message: 'Sei sicuro di voler eliminare questo coupon?',
		  buttons: [
			{
			  label: 'Sì',
			  onClick: () => {
				fetch(process.env.REACT_APP_SERVER_URL+'/coupon/'+idcoupon, {
				  method: 'DELETE',
				  headers: getJWTHeaders(),
				}).then(
				  data => {
					fetchCoupon(currentFilter);
				  }
				);
			  }
			},
			{
			  label: 'No',
			  onClick: () => {}
			}
		  ]
		});
	   }

	   const startEditing = (row) => {
		setEditingRow(row.idcoupon);
		setEditValues({
		  name: row.name || '',
		  groupinfo: row.groupinfo || '',
		  until: row.until ? new Date(row.until) : new Date(),
		  pax: row.pax || 1
		});
	   };

	   const cancelEditing = () => {
		setEditingRow(null);
		setEditValues({});
	   };

	   const saveEditing = (idcoupon) => {
		const updatedCoupon = {
		  idcoupon: idcoupon,
		  name: editValues.name,
		  groupinfo: editValues.groupinfo,
		  until: editValues.until,
		  pax: editValues.pax
		};

		fetch(process.env.REACT_APP_SERVER_URL+'/coupon/update', {
		  method: 'PUT',
		  headers: getJWTHeaders(),
		  body: JSON.stringify(updatedCoupon),
		}).then(handleResponse)
		  .then(function(data){
			fetchCoupon(currentFilter);
			setEditingRow(null);
			setEditValues({});
		  });
	   };

	   const handleSearch = (event) => {
		event.preventDefault();
		currentFilter.search = searchText;
		currentFilter.page = 1; // Reset to first page when searching
		fetchCoupon(currentFilter);
	   };

	   const clearSearch = () => {
		setSearchText('');
		currentFilter.search = '';
		currentFilter.page = 1;
		fetchCoupon(currentFilter);
	   };

	  

	  const handleSubmit = (event) => {
    
		event.preventDefault();
		
		console.log(event.target[0].value);

		currentCoupon.quantity = event.target[0].value;
		currentCoupon.name = event.target[1].value;
		currentCoupon.groupinfo = event.target[2].value;
		currentCoupon.idfilm = event.target[4].value;
		currentCoupon.pax = event.target[5].value;
		currentCoupon.until = until;
		
	
		fetch(process.env.REACT_APP_SERVER_URL+'/coupons/save', {
		  method: 'POST',
		  headers: getJWTHeaders(),
		  body: JSON.stringify(currentCoupon),
		}).then(handleResponse)
		  .then(function(data){
			fetchCoupon(currentFilter);
		  })
	
		
		
	  }

	const columns = [
		{
		  name: "Coupon",
		  selector: (row) => row.coupon,
		  sortable: true,
		  sortField:"coupon",
		  wrap: true,
		  minWidth: "150px",
		  style: {
			textOverflow: 'unset',
			whiteSpace: 'normal'
		  }
		},
		{
		  name: "Information",
		  selector: (row) => editingRow === row.idcoupon ? (
			<Form.Control 
			  type="text" 
			  value={editValues.name} 
			  onChange={(e) => setEditValues({...editValues, name: e.target.value})}
			  size="sm"
			/>
		  ) : row.name,
		  sortable: true,
		  sortField:"name"
		},
		{
			name: "Group",
			selector: (row) => editingRow === row.idcoupon ? (
			  <Form.Control 
				type="text" 
				value={editValues.groupinfo} 
				onChange={(e) => setEditValues({...editValues, groupinfo: e.target.value})}
				size="sm"
			  />
			) : row.groupinfo,
			sortable: true,
			sortField:"groupinfo"
		  },
		{
		  name: "Valid until",
		  selector: (row) => editingRow === row.idcoupon ? (
			<DatePicker 
			  dateFormat="dd/MM/yyyy" 
			  selected={editValues.until} 
			  onChange={(date) => setEditValues({...editValues, until: date})}
			  className='form-control form-control-sm'
			/>
		  ) : row.until,
		  sortable: true,
		  right: true,
		  sortField:"until"
		},
		{
			name: "Block on film",
			selector: (row) => (row.film ? row.film.internationaltitle : "-" ),
			sortable: true,
			right: true,
			sortField:"film.internationaltitle"
		  },
		{
			name: "Used",
			selector: (row) => (row.used ? 'YES' : 'NO'),
			sortable: true,
			right: true,
			sortField:"used"
		  },
		{
			name: "Pax",
			selector: (row) => editingRow === row.idcoupon ? (
			  <Form.Control 
				type="number" 
				value={editValues.pax} 
				onChange={(e) => setEditValues({...editValues, pax: e.target.value})}
				size="sm"
				min="1"
			  />
			) : (row.pax || '-'),
			sortable: true,
			right: true,
			sortField:"pax"
		  },
		{
			name: "Action",
		  selector: (row) =>
			<div>				
				{editingRow === row.idcoupon ? (
				  <>
					<Button size="sm" variant="success" onClick={() => saveEditing(row.idcoupon)} className="me-1">
					  <FontAwesomeIcon icon={["fal", "check"]} />
					</Button>
					<Button size="sm" variant="secondary" onClick={cancelEditing} className="me-1">
					  <FontAwesomeIcon icon={["fal", "times"]} />
					</Button>
				  </>
				) : (
				  <Button size="sm" variant="primary" onClick={() => startEditing(row)} className="me-1">
					<FontAwesomeIcon icon={["fal", "edit"]} />
				  </Button>
				)}
				<Button size="sm" variant="danger"  onClick={deleteCoupon} idToDelete={row.idcoupon}><FontAwesomeIcon icon={["fal", "trash"]} /></Button>
		  	</div>,
		  sortable: false,
		  right: true,
		}
	  ];

	  const fetchFilm = async () => {

		const options = {
		  method: "GET",
		  headers: getJWTHeaders()
	  };
	  
	  fetch(process.env.REACT_APP_SERVER_URL+'/film/all', 
	  options
	  )
	  .then(function(response){
	  
	  console.log(response)
	  
	  return response.json();
	  
	  })
	  
	  .then(data => setFilm(data))
	  
		}

	const fetchCoupon = async currentFilter => {

		setLoading(true);

   // instead of setTimeout this is where you would handle your API call.
		const options = {
			method: "POST",
			body: JSON.stringify(currentFilter),
			headers: getJWTHeaders()
	  };
	  
	  const response = fetch(process.env.REACT_APP_SERVER_URL+'/coupons/table', 
		options
	  ).then(handleResponse)
		.then(function(data){ 
		setData(data.coupons);
		setCurrentPage(currentFilter.page);		
		setTotalRows(data.total);
		setFilter(currentFilter);
		setPerPage(currentFilter.max)
		setLoading(false);
	  }).catch(error => 
		{
			console.error(error)
			window.location = '/pleaselogin'
		})
	};

	const handleSort = (column, sortDirection ) => {
		// simulate server sort
		console.log(column, sortDirection);
		currentFilter.direction  = sortDirection;
		currentFilter.sortcol = column.sortField;
		fetchCoupon(currentFilter);

	};

	const handlePageChange = page => {
		currentFilter.page=page;
		fetchCoupon(currentFilter);
	};

	const handlePerRowsChange = async (newPerPage, page) => {
		currentFilter.page=page;
		currentFilter.max=newPerPage;
		fetchCoupon(currentFilter);
	
	};

	useEffect(() => {
		fetchCoupon(currentFilter); // fetch page 1 of users
		fetchFilm();
	}, []);

	createTheme('solarized', {
		text: {
			primary: '#fff',
			secondary: 'rgba(0,0,0,.54)',
		},
		background: {
			default: '#48486e',
		},
		context: {
			background: '#32324e',
			text: '#FFFFFF',
		},
		divider: {
			default: '#3c3c5d',
		},
		highlightOnHover: {
			default: 'rgba(124, 58, 237, 0.25)',
			text: 'rgba(255, 255, 255, 0.85)',
		},
		striped: {
			default: 'rgba(255, 255, 255, 0.05)',
			text: '#fff',
		},
	});

	return (
		<div>
			<Container fluid={true}>
				<Row>
					<Col><h1>Coupon list</h1></Col>
					<Col className='text-end'><Button variant="primary" tag={Link} href={process.env.REACT_APP_SERVER_URL + "/retrieve/coupon/export/"}>Export coupon</Button> </Col>
				</Row>
				<Form onSubmit={handleSubmit}>
				<Row>
				<Col md={2}>
             <FormGroup>
              <Form.Label for="quantity">Quantity</Form.Label>
              <Form.Control type="number" name="quantity" id="quantity" defaultValue="1" min="1" />
            </FormGroup>
          </Col>
		  <Col md={2}>
            <FormGroup>
              <Form.Label for="name">Name</Form.Label>
              <Form.Control  type="text" name="name" id="name" 
                      />
            </FormGroup>
          </Col>
		  <Col md={2}>
            <FormGroup>
              <Form.Label for="group">Group</Form.Label>
              <Form.Control  type="text" name="group" id="group" 
                      />
            </FormGroup>
          </Col>
          <Col md={2}>
             <FormGroup>
              <Form.Label for="validuntil">Valid until</Form.Label>
              <DatePicker dateFormat="dd/MM/yyyy" selected={until} onChange={(date) => setUntil(date)} className='form-control' calendarClassName="theme-style" />
            </FormGroup>
          </Col>
		  <Col md={2}>
             <FormGroup>
              <Form.Label for="idfilm">Block on Film</Form.Label>
              <Form.Select type="select" name="idfilm" id="idfilm"  >
        <option value=""> -- Select a film -- </option>
            
      {film.map((cfilm) => <option value={cfilm.idfilm}>{cfilm.internationaltitle}</option>)}
        </Form.Select>
            </FormGroup>
          </Col>
		  <Col md={1}>
             <FormGroup>
              <Form.Label for="pax">Pax</Form.Label>
              <Form.Control type="number" name="pax" id="pax" defaultValue="1" min="1" />
            </FormGroup>
          </Col>
		  <Col md={1}>
            <FormGroup className='mt-4'>
              <Button variant="primary" type="submit" className='w-100'>Create</Button>{' '}
             
            </FormGroup>
          </Col>
		  </Row>
		  </Form>
				<Row className="mb-3">
					<Col md={8}>
						<Form onSubmit={(e) => handleSearch(e)}>
							<Row>
								<Col md={8}>
									<Form.Control 
										type="text" 
										placeholder="Cerca per codice coupon, nome o gruppo..." 
										value={searchText}
										onChange={(e) => setSearchText(e.target.value)}
									/>
								</Col>
								<Col md={2}>
									<Button variant="primary" type="submit">
										<FontAwesomeIcon icon={["fal", "search"]} className="me-1" />
										Search
									</Button>
								</Col>
								<Col md={2}>
									<Button variant="secondary" onClick={clearSearch}>
										<FontAwesomeIcon icon={["fal", "times"]} className="me-1" />
										Clear
									</Button>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
				<Row>
					<Col>
						<DataTable
							columns={columns}
							data={data}
							progressPending={loading}
							pagination
							paginationServer
							sortServer
							onSort={handleSort}
							paginationTotalRows={totalRows}
							onChangeRowsPerPage={handlePerRowsChange}
							onChangePage={handlePageChange}
							theme="solarized"
							highlightOnHover
							striped={true}
						/>
					</Col>
				</Row>

			</Container>
        </div>
	);

}